<template>
  <el-row class="header">
    <el-col :span="4" class="logo">
      <router-link to="/"><img :src="logo" alt="logo"></router-link>
    </el-col>
    <el-col :span="20" class="user-info">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{currentOrg.name}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(org, i) in profile.ownerOrgs" :key="i" @click.native="changeOrg(org.id)">{{org.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{profile.userName}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="loginout()">
            退 出
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>

    <!-- 选择组织弹出框-->
    <el-dialog title="提示" :visible.sync="init && currentOrg.name===''" :show-close='false' customClass="chooseOrgModel" style="padding-top: 10vh;">
      <!-- <div class="el-dialog__text">请选择组织</div> -->
      <el-select v-model="selectedOrgId" placeholder="请选择组织" filterable clearable>
        <el-option v-for="org in profile.ownerOrgs" :key="org.id" :label="org.name" :value="org.id">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click.prevent="closeModel">确定</el-button>
      </div>
    </el-dialog>
  </el-row>

</template>

<script>
import { getToken, setToken,removeToken } from '@/util/auth' // get token from cookie
export default {
  props: {
    logo: {
      type: String,
      default: "/static/img/" + _logo_
    },
    profile: {
      type: Object,
      default: () => {
        return { ownerOrgs: [], userName: "" };
      }
    },
    currentOrg: {
      type: Object,
      default: () => {
        return { id: "", name: "" };
      }
    },
    init: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentTimezone: { id: "", name: "" },
      selectedOrgId: "",
      showNav: false,
      active: false,
      imgUrl: "",
      menuJson: [],
      allMenuJson: []
    };
  },
  created() {},
  mounted: function() {
    var _this = this;
    this.$nextTick(function() {
      document.onclick = function() {};
    });
  },
  methods: {
    loginout: function() {
      // var r = '/logout';
      // sessionStorage.removeItem("currentOrg");
      // window.location.href = r;

      removeToken();
      // this.$router.push({ path: "/login" });
      window.location.href = '/login'
    },
    changeOrg: function(orgId) {
      this.selectedOrgId = orgId;
      let _this = this;
      this.$request1
        .post(
          '/user/profile/' + _this.selectedOrgId + '',
          {
            withCredentials: true
          }
        )
        .then(function(response) {
          _this.currentOrg = response.data.currentOrg;
          sessionStorage.setItem("currentOrg", _this.currentOrg);
          location.reload();
        })
        .catch(function(error) {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    closeModel: function() {
      let _this = this;
      this.$request1
        .post(
          '/user/profile/' + _this.selectedOrgId + '',
          {
            withCredentials: true
          }
        )
        .then(function(response) {
          let data = response.data;
          _this.currentOrg = data.currentOrg;
          _this.isShowModal = false;
          sessionStorage.setItem("currentOrg", _this.currentOrg);
          window.location.reload();
        })
        .catch(function(error) {
          console.log(error);
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    }
  }
};
</script>

<style lang="scss">
.header {
  line-height: 50px;
  position: relative;
  padding-left: 60px;
}

.logo {
  a {
    display: inline-block;
  }
}
.contact-info {
  [class*="el-icon-"] {
    font-size: 20px;
    margin-right: 10px;
  }
  span + span {
    margin-left: 6%;
  }
}
.user-info {
  text-align: right;
  font-size: 14px;
}
//下拉菜单
.el-dropdown {
  padding: 0 10px;
  .el-dropdown-link {
    display: inline-block;
    &:hover {
      color: #409eff;
      cursor: pointer;
    }
  }
}

@media (min-width: 768px) {
}

.chooseOrgModel{
  width: 400px !important;
  .el-dialog__header{
    padding: 15px;
    line-height: 1;
    .el-dialog__title{
      padding-left: 0;
      margin-bottom: 0;
      font-size: 18px;
      line-height: 1;
      color: #303133;
    }
  }
  .el-dialog__body{
    padding: 10px 15px;
    .el-dialog__text{
      line-height: 24px;
      color: #606266;
    }
    .el-select{
      width: 100%;
      margin-top: 15px;
    }
  }
  .el-dialog__footer{
    padding: 15px;
  }
  // .el-button{
  //   width: 100%;
  // }
}
</style>


// WEBPACK FOOTER //
// src/views/frame/sp-header.vue